import { normalizeCnpj } from './cnpj';
const fields = new Set(['cnpj', 'cnpjcompany', 'companycnpj', 'cpfcnpj', 'borrowercpfcnpj', 'clientdocument', 'userdocumentnumber']);
export function normalizeDocumentPayload(value) {
  if (Array.isArray(value)) return value.map(normalizeDocumentPayload);
  if (!value || Object.getPrototypeOf(value) !== Object.prototype) return value;
  return Object.fromEntries(Object.entries(value).map(([key, item]) => [key,
    fields.has(key.replace(/_/g, '').toLowerCase()) && typeof item === 'string'
      ? normalizeCnpj(item) : normalizeDocumentPayload(item)]));
}
export function normalizeDocumentRequest(config) {
  config.data = normalizeDocumentPayload(config.data);
  config.params = normalizeDocumentPayload(config.params);
  return config;
}
